import React, {Component} from 'react'
import classNames from 'classnames'
import Link from 'next/link'
import Slideshow from '../Slideshow/Slideshow'
import {getArticlePath, getArticlePathVisible} from '../../routes/paths'
import {getHostedImage, IMAGE_SIZE_LARGE, IMAGE_SIZE_LARGE_MOBILE} from '../../utils/images'

class ArticlesCarousel extends Component {
  constructor (props) {
    super(props)
    this.renderSlides = this.renderSlides.bind(this)
  }

  getImageSize () {
    const {isMobileLayout} = this.props
    return (isMobileLayout) ? IMAGE_SIZE_LARGE_MOBILE : IMAGE_SIZE_LARGE
  }

  getSlideStyle (article) {
    if (!article.previewImage) {
      return {}
    }
    return {
      backgroundImage: `url(${getHostedImage(article.previewImage.url, this.getImageSize())})`
    }
  }

  getAltText (article) {
    return (article && article.previewImage && article.previewImage.altText) || ''
  }

  renderSlides () {
    const {articles} = this.props
    return articles.map((article, index) => (
      <div className='ArticlesCarousel__image' key={index}>
        <div className='ArticlesCarousel__image__inner' style={this.getSlideStyle(article)} aria-label={this.getAltText(article)} role='img' />

        <div className='ArticlesCarousel__slide'>
          <div className='ArticlesCarousel__slide__content'>
            <div className='ArticlesCarousel__slide__categoryWrapper'>
              <div className='ArticlesCarousel__slide__category'>{article.category.name}</div>
            </div>
            <div className='ArticlesCarousel__slide__info'>
              <h4 className='ArticlesCarousel__slide__title'>
                {/* <Link href={getArticlePath(article.slug)} as={getArticlePathVisible(article.slug)}>
                  <a>{article.heading}</a>
                </Link> */}
                <a href={`/article/${article.slug}`}>
                  <a>{article.heading}</a>
                </a>
              </h4>
            </div>
            <div className='ArticlesCarousel__slide__readMore'>
              {/* <Link href={getArticlePath(article.slug)} as={getArticlePathVisible(article.slug)}>
                <a>Read More</a>
              </Link> */}
              <a href={`/article/${article.slug}`}>
                <a>Read More</a>
              </a>
            </div>
          </div>
        </div>

      </div>
    ))
  }

  render () {
    const {className, articles} = this.props
    return (
      <div role='region' aria-label='Must Reads' className={classNames([
        'ArticlesCarousel',
        className
      ])}>
        <div className='ArticlesCarousel__imageWrapper'>
          <Slideshow dots={(index, goto) => (
            <div className='ArticlesCarousel__nav'>
              {
                articles.map((article, i) => (
                  <div className={classNames([
                    'ArticlesCarousel__nav__dot',
                    {
                      'ArticlesCarousel__nav__dot--active': i === index
                    }
                  ])} key={i} onClick={() => {
                    goto(i)
                  }} />
                ))
              }
            </div>
          )} className={'ArticlesCarousel__imageWrapper__slideShow'}>{this.renderSlides()}</Slideshow>
        </div>
      </div>
    )
  }
}

ArticlesCarousel.defaultProps = {
  className: ''
}

export default ArticlesCarousel



// WEBPACK FOOTER //
// ./client/components/ArticlesCarousel/ArticlesCarousel.js